import React, { useState, useRef } from 'react';
import './MobileLayoutModal.css';
import { useTravarScroll, useFocoNoModal } from '../utils/travarScroll';
import { useFechavelComVoltar } from '../contexts/VoltarDoCelular';

interface Section {
  id: string;
  label: string;
}

interface MobileLayoutModalProps {
  sections: Section[];
  onApply: (newOrder: string[]) => void;
  onClose: () => void;
}

const MobileLayoutModal: React.FC<MobileLayoutModalProps> = ({ sections, onApply, onClose }) => {
  useTravarScroll();
  /* O voltar do celular fecha isto antes de sair do app. */
  useFechavelComVoltar(true, onClose);
  const caixa = useRef<HTMLDivElement>(null);
  useFocoNoModal(caixa);

  const [order, setOrder] = useState<Section[]>(sections);

  const move = (index: number, direction: 'up' | 'down') => {
    const next = [...order];
    const target = direction === 'up' ? index - 1 : index + 1;
    if (target < 0 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]];
    setOrder(next);
  };

  const handleApply = () => {
    onApply(order.map(s => s.id));
    onClose();
  };

  return (
    <div className="mlm-backdrop" onClick={onClose} ref={caixa}>
      <div className="mlm-sheet" onClick={e => e.stopPropagation()}>
        <div className="mlm-handle-bar" />

        <div className="mlm-header">
          <span className="mlm-title">Organizar seções</span>
          <button className="mlm-close" onClick={onClose} aria-label="Fechar">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4 4l10 10M14 4L4 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <p className="mlm-subtitle">Use as setas para mudar a ordem das seções</p>

        <ul className="mlm-list">
          {order.map((section, index) => (
            <li key={section.id} className="mlm-item">
              <span className="mlm-item-index">{index + 1}</span>
              <span className="mlm-item-label">{section.label}</span>
              <div className="mlm-item-arrows">
                <button
                  className="mlm-arrow-btn"
                  onClick={() => move(index, 'up')}
                  disabled={index === 0}
                  aria-label="Mover para cima"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M3 9l4-4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button
                  className="mlm-arrow-btn"
                  onClick={() => move(index, 'down')}
                  disabled={index === order.length - 1}
                  aria-label="Mover para baixo"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M3 5l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </li>
          ))}
        </ul>

        <div className="mlm-footer">
          <button className="mlm-btn-cancel" onClick={onClose}>Cancelar</button>
          <button className="mlm-btn-apply" onClick={handleApply}>Aplicar</button>
        </div>
      </div>
    </div>
  );
};

export default MobileLayoutModal;
